/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'

function SEO({ description, lang, meta, title, url, children }) {
  const metaDescription = description || 'Receive SMS online with the webs only exclusive temp numbers. Always free, no signup required.'
  const metaTitle = title || 'Receive SMS | Exclusive Free Temporary Phone numbers'
  return (
    <Helmet
      htmlAttributes={{
        lang
      }}
      title={title}
      titleTemplate={title}
      meta={[
        {
          name: `description`,
          content: metaDescription
        },
        {
          property: `og:title`,
          content: metaTitle
        },
        {
          property: `og:image`,
          content: 'https://wereceivesms.com/ogimage.png'
        },
        {
          property: `og:url`,
          content: url
        },
        {
          property: `og:description`,
          content: metaDescription
        },
        {
          property: `og:type`,
          content: `website`
        },
        {
          name: `twitter:card`,
          content: `summary`
        },
        {
          name: `twitter:title`,
          content: metaTitle
        },
        {
          name: `twitter:description`,
          content: metaDescription
        },
        {
          name: `twitter:card`,
          content: 'summary'
        },
        {
          name: `twitter:image`,
          content: 'https://wereceivesms.com/ogimage.png'
        }
      ].concat(meta)}
    >
      {children}
      <link rel="icon" type="image/svg+xml" href="/favicon-new.svg" />
      <link rel="alternate icon" href="/favicon-new.png" />
      {/* <script
        async
        src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-3580818377622359"
        crossorigin="anonymous"
      ></script> */}
      {/* <script type="application/ld+json">{`{
        "@context": "http://schema.org",
        "@graph": [
          {
            "@type": "Product",
            "name": "Receive a SMS Online",
            "description":
              "The largest collection of temporary phone numbers on the internet. 18+ Countries, 100+ numbers. 100% free, no registration.",
            "brand": "Temporary phone number",
            "image": "https://receiveasmsonline.com/static/eb31a06be179f33a00239e96733561d6/959c9/heroPhone.webp",
            "itemCondition": ["http://schema.org/NewCondition"],
            "slogan": "The largest collection of temporary phone numbers on the internet. 18+ Countries, 100+ numbers. 100% free, no registration.",
            "offers": {
              "@type": "Offer",
              "availability": "http://schema.org/InStock",
              "price": "Free",
              "priceCurrency": "GBP"
            },
            "aggregateRating": { "@type": "AggregateRating", "ratingCount": 3235, "ratingValue": 4.98 }
          }
        ]
      }`}</script> */}
    </Helmet>
  )
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired
}

export default SEO
